import React from 'react'
import PropTypes from 'prop-types'

import styled from 'styled-components'
import { Chip } from '@material-ui/core'
import { colors } from '@/theme'
import { ORDER_TYPES_LABELS } from '@/_mock/orders'

// ------------------------------------------------------

const StyledChip = styled(Chip)`
  font-size: 0.68rem;
  background-color: ${colors.color100};
`

// ------------------------------------------------------

export function OrderTypeBadge(props) {
  const { variant, ...other } = props

  const label = ORDER_TYPES_LABELS[variant]

  return <StyledChip size="small" label={label} {...other} />
}

OrderTypeBadge.propTypes = {
  variant: PropTypes.string,
}
